import * as React from 'react'

import { BackToTopButton } from 'sdk/back-to-top-button/BackToTopButton'
import { SocialNetworks } from 'sdk/social-networks/SocialNetworks'
import { Content } from 'sdk/components'
import { useAppSelector } from 'redux/store'

import { FooterMenuItems } from './FooterMenuItems'

import logo from 'images/logo.png'
import logoRetina from 'images/logo@2x.png'

import classes from './style.module.scss'

interface ComponentProps {
  showJobs: boolean
  renderMenuItems?: boolean
}

export const Footer: React.FC<ComponentProps> = ({ showJobs, renderMenuItems = false }) => {
  const links = useAppSelector((state) => state.settings.links)

  return (
    <Content
      mainWrapperClassName={classes.wrapper}
      className={classes.container}
    >
      <BackToTopButton className={classes.backToTopButton} />
      <div className={classes.headerContainer}>
        <div className={classes.logo}>
          <img
            src={logo}
            srcSet={`${logo} 1x, ${logoRetina} 2x`}
            alt="GPU Audio logo"
          />
        </div>
        <SocialNetworks />
      </div>

      { renderMenuItems && (
        <FooterMenuItems showJobs={showJobs} links={links!} />
      ) }

      <hr />

      <div className={classes.footerContainer}>
        <div className={classes.legal}>
          © 2017-2025, GPU Audio Inc. All rights reserved.
        </div>
      </div>
    </Content>
  )
}
